<!--盘点单 数量类型商品-->
<template>
  <div>
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="仓库" :label-width="formLabelWidth" prop="cangkucode" size="small"
                        style="text-align: left;">
            <el-select v-model="form.cangkuname" placeholder="请选择" @change="changename"
                       :required="true" v-if="btnvisible">
              <el-option
                v-for="item in jxcstoreDataf"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item">
              </el-option>
            </el-select>
            <span v-else>{{form.cangkuname}}&nbsp;&nbsp;<br>{{form.accdate}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item label="货品名称" :label-width="formLabelWidth" prop="seedname" size="small"
                        style="text-align: left;">
            <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindData" :isShowCheckBox="false"
                        v-model="form.seedname" :treeWidth="340" v-if="btnvisible"
                        :treeHeight="350" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>
            <span v-else>{{form.seedname}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-show="false">
        <el-col :span="10">
          <el-form-item label="盘点日期" :label-width="formLabelWidth" prop="accdate">
            <el-input v-model="form.accdate" auto-complete="off" :required="true" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="btnvisible">
        <el-col :span="24">
          <div style="float: left;padding-left: 120px">{{subinfo}}</div>
          <div style="float: right;padding-right: 100px"> <el-button type="warning" @click="add2Table" v-if="isyinxin&&btnvisible" size="mini">增 加</el-button>
            <template v-if="isyinxin">
            <el-button type="warning" @click="importEdit" size="mini" >导入隐形</el-button>
            <a href="./static/file/隐形导入格式.xls">下载模板</a>
             </template>
            <input type="file" ref="fileupload1" style="display: none;" @change="change1($event)"/></div>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="form.needaudit == 1">
        <el-col :span="24">
          <div style="float: left;padding-left: 120px">{{subinfo}}</div>
          <div style="float: right;padding-right: 100px" v-if="extendForm.storenumbers">
            <el-button type="success" @click="showChangepdd" v-if="!onauditchange">修改盘点单</el-button>
            <el-button type="primary" @click="saveChangepdd" v-if="onauditchange">保存修改</el-button>
            <el-button type="info" @click="onauditchange=false" v-if="onauditchange">取消修改</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24" v-if="isyinxin">
          <el-form-item label="" :label-width="formLabelWidth">
          <el-table
            :data="tableData"
            size="mini"
            stripe
            border
            style="width: 100%;">
            <el-table-column
              prop="certorg" :show-overflow-tooltip="true"
              label="厂家"
              align="left" width="100"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="certno" :show-overflow-tooltip="true"
              label="注册证号"
              align="left" width="140"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="batchno" :show-overflow-tooltip="true"
              label="批次号"
              align="left" width="120"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="endtime" :show-overflow-tooltip="true"
              label="失效日期"
              align="left"  width="100"
              header-align="center">
              <template slot-scope="scope">
                {{scope.row.endtime?scope.row.endtime.split(' ')[0]:''}}
              </template>
            </el-table-column>
            <el-table-column
              prop="P"
              label="库存"
              align="center" v-if="btnvisible||showKucun||onauditchange"
              width="70"
              header-align="center">
              <template slot-scope="scope">
                <span style="color: red;font-weight: bolder" v-if="scope.row.P>scope.row.totalnumber">{{scope.row.P}}</span>
                <span style="color: blue;font-weight: bolder" v-if="scope.row.P<scope.row.totalnumber">{{scope.row.P}}</span>
                <span v-if="scope.row.P==scope.row.totalnumber">{{scope.row.P}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="totalnumber"
              label="盘点数"
              align="center"
              width="90"
              header-align="center">
              <template slot-scope="scope">
                <el-input-number :controls="false" style="width: 100%" :min="0" size="small" v-if="btnvisible||onauditchange" v-model="scope.row.totalnumber"
                                 onfocus="this.select()"
                                 @change="yxTotal"></el-input-number>
                <span v-else>{{scope.row.totalnumber}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="差异数"
              align="center"
              header-align="center" v-if="btnvisible||showKucun||onauditchange"
              width="80">
              <template slot-scope="scope">
                <span> {{calNum(scope.row)}}</span>
              </template>
            </el-table-column>
          </el-table>
          </el-form-item>
        </el-col>
        <el-col :span="16" v-else>
          <el-form-item label="数量" :label-width="formLabelWidth">
            <el-input v-model="form.totalnumber" auto-complete="off" :required="true" v-if="btnvisible||onauditchange" style="width: 100px" @change="subData"></el-input>  <span v-else>{{form.totalnumber}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="说明" :label-width="formLabelWidth">
            <el-input
              type="textarea" v-if="btnvisible||onauditchange"
              :rows="1"
              v-model="form.remark">
            </el-input>
            <span v-else>{{form.remark}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <AddYinXing ref="AddYinXing1" @afterAddYX="afterAddYX" :lens="false"></AddYinXing>
    <!--<div slot="footer" class="dialog-footer">-->
      <!--<el-button @click="close()">取 消</el-button>-->
      <!--&lt;!&ndash;<el-button type="warning" @click="toZero(false)" plain v-if="btnvisible">清零</el-button>&ndash;&gt;-->
      <!--&lt;!&ndash;<el-button type="warning" @click="toZero(true)" plain v-if="btnvisible">还原</el-button>&ndash;&gt;-->
      <!--<el-button type="primary" @click="saveData" v-if="btnvisible" :loading="loading">保 存</el-button>-->
    <!---->
    <!--</div>-->
  </div>
</template>


<script>
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import AddYinXing from './AddYinXing';
  import {getControlData,getPrice} from '@/api/set/goodsprice';
  import {inventorySave} from '@/api/set/jxcstoreform';
  import {looklist} from '@/api/set/jxcstoreformdetail';
  import {getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {formatTimeToStr} from '@/plugin/Date';

  export default {
    name: 'MakeInventoryOtherEdit',
    msg: '盘点单',
    data() {
      return {
        addvisible: true,
        isyinxin:false,
        tableData:[],
        loading:false,
        guids: '',//商品编码
        categorycode:'',
        subinfo:'',
        showKucun:false,
        onauditchange:false,
        storenum:0,
        form: {  //表单数据
          unitguid:'',
          changeunitguid:'',
          accdate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
          cangkucode: '',
          cangkuname: '',
          packagesizes: '',
          seedcode: '',
          seedname: '',
          needaudit:'',
          status: 10,
          formtype: 74,
          filltemplate: '40',
          auditcontent:'',
          remark: '',
          totalnumber: 0,
          physicalstore:'',
          physicalstorecode:'',
          barcode:'',
        },
        extendForm:{
          storenumbers:null,
          yinxincert:null,
        },
        packagesizes: [],//存储盘点数据
        formLabelWidth: '120px',
        btnvisible: true,//控制确定按钮显示、隐藏
        rules: {////////定义正则验证字段。
          cangkucode: [
            {required: true, message: '请选择仓库', trigger: 'blur'},
          ],
          seedname: [
            {required: true, message: '请选择货品', trigger: 'change'},
          ],
        },
      }
    },
    props:{
      jxcstoreDataf:[]
    },
    methods: {
      close() {
        this.$emit('close');
      },
      importEdit() {
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      calNum(row) {
        if (!row.totalnumber)
          row.totalnumber = 0;
        if (!row.P)
          row.P = 0;
        if (row.P == row.totalnumber)
          return '';
        return -(row.P - row.totalnumber);
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              let arr = []
              let obj = {}
              if (this.isyinxin) {
                this.toZero(false);
                for (let i in data) {
                  var item = data[i]
                  var P = parseInt(item["数量"]);
                  if (!P || P <= 0) continue;
                  var batchno = item["批次号"];
                  if (!batchno) continue;
                  var seedc = item["商品编码"];
                  if (seedc && seedc != this.form.seedcode) {
                    continue;
                  }

                  var hasValue = false;
                  for (let j in this.tableData) {
                    var row = this.tableData[j];
                    if (row.batchno == batchno) {
                      row.totalnumber += P;
                      hasValue = true;
                      break;
                    }
                  }
                  if (!hasValue) {
                    if (!item["有效期"] || !item["厂家"] || !item["证号"]) continue;
                    var d = new Date(item["有效期"]);
                    this.tableData.push({
                      totalnumber: P,
                      P: 0,
                      batchno: batchno,
                      certno: item["证号"],
                      certorg: item["厂家"],
                      endtime: d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
                    });
                  }
                }
                this.yxTotal();
              }
            }
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      add2Table() {
        this.$refs.AddYinXing1.show(this.form.seedcode, this.costpricebook, this.tableData);
      },
      showChangepdd() {
        this.onauditchange = true;
      },
      saveChangepdd(){
        this.form.changeunitguid = this.form.unitguid;
        this.saveData();
      },
      afterAddYX(row) {
        this.tableData.push(row)
        this.yxTotal();
      },
      subData() {
        var cSub = this.form.totalnumber - this.storenum;
        this.subinfo = '盘点：' + this.form.totalnumber + ' 、库存：' + this.storenum + ' 、' + (cSub == 0 ? '无差异！' : ((cSub > 0 ? '盘盈：' : '盘亏：') + cSub));
      },
      show(cangkucode) {
        this.initForm();
        this.changename({cangkucode: cangkucode});
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.loading = true
            var barcode = [];

            if (this.isyinxin) {
              for (var i in this.tableData) {
                var Row = this.tableData[i]
                Row.oldtn = Row.totalnumber;
                Row.seedcode = this.form.seedcode;
                Row.seedname = this.form.seedname;
                Row.packagesize = ''
                var P = parseInt(Row.totalnumber) - parseInt(Row.P);
                if (P != undefined && P != 0) {
                  Row.totalnumber = P;
                  barcode.push(Row);
                }
              }
            }
            var showtotal=this.form.totalnumber;
            this.form.auditcontent = this.subinfo;
            this.form.totalnumber = this.form.totalnumber - this.storenum;
            this.form.physicalstore = this.form.seedname
            this.form.physicalstorecode = this.form.seedcode
            this.form.barcode = barcode.length > 0 ? JSON.stringify(barcode) : ''
            if(this.form.accdate){
              var accD=new Date(this.form.accdate);
              this.form.accdate=accD.getFullYear() + '-' + (accD.getMonth() + 1) + '-' + accD.getDate();
            }
            inventorySave(this.form).then(response => {
              this.form.totalnumber=showtotal;
              if (this.isyinxin) {
                for (var i in this.tableData) {
                  var Row = this.tableData[i]
                  Row.totalnumber = Row.oldtn;
                }
              }

              if (response.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                //刷新列表
                this.$emit('bindGrid');
                if (this.form.changeunitguid) {
                  this.onauditchange = false;
                } else {
                  this.close();
                }
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
              this.form.changeunitguid=''
              this.loading = false;
            });
            //
          } else {
            this.form.changeunitguid=''
            this.loading = false
          }
        })

      },
      toFormat() {
        this.toZero(true);
      },
      toZero(isback) {
        if (this.isyinxin) {
          for (let i in this.tableData) {
            this.tableData[i].totalnumber = isback ? this.tableData[i].P : 0;
          }
          return
        }
      },
      initData(response) {
        this.initForm()
        this.btnvisible = false
        this.showKucun = true;

        for (let i in  this.form) {
          this.form[i] = response.data.obj[i];
        }
        this.extendForm.storenumbers = response.data.obj.storenumbers;
        this.extendForm.yinxincert = response.data.obj.yinxincert;

        if (response.data.barcode && response.data.barcode.length > 0) {
          this.isyinxin = true;
          this.form.filltemplate = 10;
          this.tableData = response.data.barcode;
          for (let i in this.tableData) {
            if (this.tableData[i].packagesize) {
              this.tableData[i].X = JSON.parse(this.tableData[i].packagesize).X;
              this.tableData[i].Y = JSON.parse(this.tableData[i].packagesize).Y;
            }
          }
          this.subinfo = '';
        }
        if (this.form.needaudit == 1||this.extendForm.storenumbers) {//审核中的 显示当前库存
          this.checktree1(this.form.seedcode, this.form.seedname, [{
            parentId: this.isyinxin ? '010' : '001',
            attributes: {filltemplate: this.form.filltemplate}
          }]);
          return;
        } else {
          this.showKucun = false;
        }
      },
      //初始化
      initForm() {
        this.costpricebook = {}
        if (this.$refs.form1 !== undefined)
          this.$refs.form1.resetFields();
        this.form.seedname = ""
        this.form.seedcode = ""
        this.form.discountdetail = ""
        this.onauditchange=false;
        this.extendForm.storenumbers=null;
        this.extendForm.yinxincert=null;
        this.form.remark = ''
        this.form.totalnumber = 0
        this.form.cangkucode = ''
        this.form.cangkuname = ''
        this.form.needaudit=''
        this.form.accdate = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate();
        this.isyinxin = false;
        this.showKucun = false;
        this.form.unitguid='';
        this.form.changeunitguid='';
        this.tableData = []
        this.categorycode = ''
        this.loading = false
        this.btnvisible = true;
        this.form.enabled = 1
        this.index = ''
        this.storenum = 0;
        this.subData();
      },
      //商品树
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1, filltemplates: '40'})
        })
      },
      //选择商品树所执行的方法
      checktree1(guids, names, arr) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i]['attributes']['filltemplate']) {
            this.form.filltemplate = arr[i]['attributes']['filltemplate']
            break
          }
        }
        this.form.seedcode = guids//商品编码
        this.form.seedname = names//商品名称
        this.categorycode = arr[0].parentId;
        this.isyinxin = false;
        if (this.form.seedname == "") {
          this.$message({
            message: '请选择货品',
            type: 'warning'
          })
          return
        }

        this.getXYRange()
      },
      //二维表展示范围
      getXYRange() {
        if (this.btnvisible || this.showKucun) {
          this.createPriceBook()
        }
      },
      yxTotal() {//隐形合计
        var subnum = 0;
        for (let i in this.tableData) {
          subnum += this.tableData[i].totalnumber;
        }
        this.form.totalnumber = subnum;
        this.subData();
      },
      changename(val) {
        this.form.cangkucode = val.cangkucode;
        for (let i in this.jxcstoreDataf) {
          if (this.jxcstoreDataf[i].cangkucode == val.cangkucode) {
            this.form.cangkuname = this.jxcstoreDataf[i].cangkuname;
            break;
          }
        }
        this.createPriceBook()
      },
      createPriceBook() {
        if (!this.form.seedcode)
          return;
        if (this.extendForm.storenumbers!=null) {
          this.showKucun=true;
          var sn=this.extendForm.storenumbers;
          for(let i in sn){
            sn[i].deliverying=sn[i].delin;
            sn[i].subtractnum=sn[i].closen;
            sn[i].seedcode=sn[i].SeedCode;
            sn[i].packagesize=sn[i].Packagesize;
          }
          this.subinfo=this.form.auditcontent;
          if (this.extendForm.yinxincert!=null) {
            this.isyinxin = true;
            var arrSC=[];
            arrSC.push(this.form.seedcode);
            this.initWithStoredetail(this.extendForm.yinxincert,arrSC,sn);
          }else{
            this.isyinxin = false;
            this.initWithStoredetail([],[],sn);
          }
          return;
        }

        this.isyinxin = false;
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1
        this.storenum = 0;

        //取当前库存
        getGoodsListWithStoreDetail({
          seedcode: this.form.seedcode,//
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1,
          nolimit: 1,
          nodeliverying: 1,
          nobuynum: 1,
          cangkucode: this.form.cangkucode,
          calculateStore: "1",
          showyinxing: "2"
        }).then(resStore => {
          this.initWithStoredetail(resStore.data.barcode,resStore.data.barcodeseed,resStore.data.obj);
        });
      },
      initWithStoredetail(barcode,barcodeseed,storeData){
        var AddtableData= JSON.parse(JSON.stringify(this.tableData));
        this.tableData = []
        for (let j in barcodeseed) {
          if (barcodeseed[j] == this.form.seedcode) {
            this.isyinxin = true;
            this.tableData = barcode;
            for (let i in this.tableData) {
              this.storenum += this.tableData[i].totalnumber;
              this.tableData[i].P = this.tableData[i].totalnumber;
            }
            break;
          }
        }
        if (!this.isyinxin) {
          for (let i in storeData) {
            this.storenum += storeData[i].subtractnum;
          }
        }else{
          if(this.showKucun){
            for(let i in AddtableData){
              var newRow = this.existXY(this.tableData, AddtableData[i].batchno);
              if(newRow!=null){
                newRow.totalnumber+=AddtableData[i].totalnumber;
              }else{
                AddtableData[i].P=0;
                this.tableData.push(AddtableData[i]);
              }
              this.form.totalnumber+=AddtableData[i].totalnumber;
            }
          }
        }
        if (this.showKucun) {
          this.form.totalnumber += this.storenum;
        } else {
          this.form.totalnumber = this.storenum;
        }
        this.subData()
      },
      existXY(rows,batchno){
        for(let i in rows){
          if(rows[i].batchno==batchno){
            return rows[i];
          }
        }
        return null;
      }
    },
    components: {
      AddYinXing
    },

    mounted() {
    },
  }
</script>

<style scoped>
  .titlecolor {
    color: #20A0FF
  }

  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .erweitable td {
    border: 1px solid #E0DFDF;
    min-width: 80px;
    max-width: 100px;
    text-align: center;
    vertical-align: center;
  }

  .erweitable .content {
    border: none;
    padding: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/warehouse/MakeInventoryOtherEdit.vue